import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { IRolePermission, IRoleContent } from '../../../types/store';
import { Chip } from '@mui/material';
import { EditButton } from '../../Buttons/EditButton';
import { ViewButton } from '../../Buttons/ViewButton';
import { DeleteButton } from '../../Buttons/DeleteButton';

export const getRolesAndPermissionsColumns = (
  onClickEdit: (role: IRoleContent) => void,
  onClickView: (role: IRoleContent) => void,
  onClickDelete: (role: IRoleContent) => void,
): GridColDef[] => {
  return [
    {
      field: 'id',
      headerName: 'ID',
      minWidth: 100,
    },
    {
      field: 'name',
      headerName: 'Role',
      minWidth: 150,
    },
    {
      field: 'description',
      headerName: 'Description',
      minWidth: 150,
    },
    {
      field: 'permissions',
      headerName: 'Permissions',
      minWidth: 500,
      renderCell: (params: GridRenderCellParams) => {
        const row = params.row?.permissions as IRolePermission[];
        return (
          <>
            {row?.map((p: IRolePermission) => (
              <Chip label={p.name} key={p.name} sx={{ marginRight: 1, marginBottom: 1 }} />
            ))}
          </>
        );
      },
    },
    {
      field: 'actions',
      headerName: 'Actions',
      minWidth: 150,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <>
            <ViewButton onClick={() => onClickView(params.row)} />
            <EditButton onClick={() => onClickEdit(params.row)} />
            <DeleteButton onClick={() => onClickDelete(params.row)} />
          </>
        );
      },
    },
  ];
};
